// extracted by extract-css-chunks-webpack-plugin
module.exports = {"warning":"#f8d13a","greyLight":"#b5b5b5","container":"LinkSection_container-2tyYb","sectionTitle":"LinkSection_sectionTitle-29anU","cont":"LinkSection_cont-2rENv"};